import { useEffect } from 'react'
import gql from '../utils/graphql'
import { authorize } from '../graphql/queries'
import { get } from 'lodash'

const useAuth = (sessionId, endSession) => {
  const withAuth = async () => {
    try {
      const res = get(
        await gql({
          operation: authorize,
          path: 'authorize',
          variables: {
            sessionId
          }
        }),
        'statusCode',
        401
      )
      if (res !== 200) {
        throw new Error()
      }
    } catch (e) {
      endSession()
    }
  }

  useEffect(() => {
    if (sessionId) {
      withAuth()
    } else {
      endSession()
    }
  })
}

export default useAuth
